import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors'
import * as background from '../../config/backgroundColor'
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as brush from '../../config/brush';
import * as datazoom from '../../config/datazoom';
import * as fontStyle from '../../config/textStyle'
import { columnData, axisLabelRotate, legendPosition } from './basic-bar-interface'
import { CommonService } from '../../service/common.service'
import { ChartOptionService } from '../../service/chart-option.service';

@Injectable({
  providedIn: 'root'
})
export class BasicBarService {

  constructor(
    private commonService: CommonService
  ) { }

  // 获取柱状图默认option
  getColumnChartDefaultOption() {
    let style = this.commonService.changeFontSize()
    let option = {
      backgroundColor: background.backgroundColor,
      color: color.defaultColors,
      grid: style.interval,
      legend: legend.getLegendBottomScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getCommonTooltipOfAxis(),
      xAxis: xAxis.getCategoryXAxis(style),
      yAxis: yAxis.getYaxisOfValue(style),
      series: series.getColumnChartSeries(style),
      textStyle: fontStyle.getTextStyle()
    }
    return option;
  }
  // 更改图例显示状态
  changeLegendShow(chartOpt, bcacLegendShow: boolean) {

    chartOpt.legend.show = bcacLegendShow;
  }
  // 更改图例位置
  changeLegendPosition(chartOpt, position: legendPosition) {
    let style = this.commonService.changeFontSize();

    switch (position) {
      case 'none':
        chartOpt.legend = legend.getLegendNotShow(style)
        chartOpt.grid = style.noLegendGrid;
        break;
      case 'top':
        chartOpt.legend = legend.getLegendNotShow(style)
        chartOpt.grid = style.interval
        break;
      case 'bottom':
        chartOpt.legend = legend.getLegendBottomScroll(style)
        chartOpt.grid = style.interval
        break;
      case 'right':
        chartOpt.legend = legend.getLegendRightScroll(style)
        chartOpt.grid = style.rightLegendGrid
        break;
    }
  }
  // 更改toolbox显示状态
  // changeToolboxShow(chartOpt, bcacToolboxShow: boolean) {
  //   chartOpt.toolbox.show = bcacToolboxShow;
  // }
  // 更改brush开关状态
  changeBrushStatus(chartOpt, style, callback?: ($evetn, ...arg: any[]) => void) {
    if (callback) {
      chartOpt.brush = brush.getLineXBrush()
      chartOpt.toolbox = toolbox.getToolboxIncludeCalc(style, callback);
    }
  }

  // 更改数据
  changeChartData(chartOpt, data, barBackgroundShow) {
    let style = this.commonService.changeFontSize()
    if (data && data.hasOwnProperty('xData')) {
      chartOpt.xAxis[0].data = data.xData;
    }
    if(data && data.hasOwnProperty('xAxisTooltipUnit')) {
      chartOpt.tooltip = tooltip.getCommonTooltipOfAxis('','',data.xAxisTooltipUnit);
    }
    chartOpt.series = series.getColumnChartSeries(style, data)
    chartOpt.series.forEach(e => {
      e.showBackground = barBackgroundShow;
    });
  }
  // 更改tooltipUnit
  changeTooltipUnit(chartOpt, tooltipUnit: string | string[]) {
    chartOpt.tooltip = tooltip.getCommonTooltipOfAxis(tooltipUnit)
  }
  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }
  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string) {
    chartOpt.yAxis[0].name = yAxisName;
  }
  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number) {
    chartOpt.yAxis[0].nameGap = yAxisNameGap;
  }
  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }
  // y轴label的旋转
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
    // chartOpt.yAxis[0].axisLabel.formatter = (value: string): string => {
    //   let valueText = '';
    //   if (value.length > 5) {
    //     valueText = value.substring(0, 5) + '...'
    //   } else {
    //     valueText = value
    //   }
    //   return valueText;
    // }
  }
  // 在toolbox导出excel图标
  addExcelIntoToolbox(chartOpt, callback?: (...args: any[]) => void) {
    let style = this.commonService.changeFontSize();
    if (callback) {
      delete chartOpt['brush'];
      chartOpt.toolbox = toolbox.getToolboxIncludeExcel(style, callback)
    }
  }
  // 设置interval
  setInterval(chartOpt, interval: number) {
    chartOpt.xAxis[0].axisLabel.interval = interval;
  }
  // 顶部图例改变
  topLegendChange(legendData: any, chartInstance) {
    legendData.forEach(e => {
      if (e.checked) {
        chartInstance.dispatchAction({
          type: "legendSelect",
          name: e.value
        })
      } else {
        chartInstance.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }
  // 更改图背景色
  changeChartBackground(chartOption, chartBackground) {
    if (typeof (chartBackground) === 'string') {
      chartOption.backgroundColor = chartBackground;
    } else {
      chartOption.backgroundColor = background.darkModeBGColor;
    }
  }
  // 开启y轴 简单模式（y轴只显示最大最小两个刻度）
  openSimplifyYAxis(chartOption) {
    let style = this.commonService.changeFontSize()
    let tempAxis = yAxis.getSimplifyYAxisOfValue(style);
    chartOption.yAxis[0].min = tempAxis.min;
    chartOption.yAxis[0].max = tempAxis.max;
    chartOption.yAxis[0].interval = tempAxis.interval;
  }
  // 改变x轴formatter
  changeXAxisFormat(chartOptions) {
    chartOptions.xAxis[0].axisLabel.formatter = (value: string): string => {

      if (!_.isNil(value)) {
        return value.slice(-2);
      } else {
        return value;
      }
    }
  }
  // 改变值轴(y轴)Interval
  changeYAxisMinInterval(chartOption, minInterval) {
    chartOption.yAxis[0].minInterval = minInterval;
  }

  // 修改
  changeYAxisLabelSplit(chartOption, splitSwitch) {
    if (splitSwitch == false) {
      chartOption.yAxis[0].axisLabel.formatter = (value): string => {
        return value.toFixed(0);
      }

    }
  }
  // min
  changeYAxisMin(chartOption, min) {
    chartOption.yAxis[0].min = min;
  }
  // max
  changeYAxisMax(chartOption, max) {
    chartOption.yAxis[0].max = max;
  }
  //interval
  changeYAxisInterval(chartOption, interval) {
    chartOption.yAxis[0].interval = interval;
  }

  changeBarSeriesBackgroundStatus(chartOption, show: boolean) {
    if (chartOption.series && Array.isArray(chartOption.series)) {
      chartOption.series.forEach(element => {
        element.showBackground = show;
      });
    }
  }

  setXAxisLabelFormat(chartOption, xAxisLabelFormat: number[]) {
    if (_.isNil(xAxisLabelFormat[0])) {
      xAxisLabelFormat[0] = 0
    }
    if (_.isNil(xAxisLabelFormat[1])) {
      xAxisLabelFormat[1] = 0
    }
    chartOption.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      valueText = value.slice(xAxisLabelFormat[0], xAxisLabelFormat[1]);
      return valueText;
    }
  }
}
